export default "__VITE_ASSET__n$pHES2M__"